import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Button,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardAddNedDrugOrderItemUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardAddNedDrugOrderItemUX-div-0"
        style={{height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardAddNedDrugOrderItemUX-div-1"
          style={{ marginBottom: "40px" }}>

          <FormGroup
            id="CardAddNedDrugOrderItemUX-FormGroup-5"
            inline={true}>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-7"
              inline={true}>
              <div
                id="CardAddNedDrugOrderItemUX-div-16"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardAddNedDrugOrderItemUX-label-26">
                  Date
                </label>
                <DateTextBox
                  id="CardAddNedDrugOrderItemUX-DateTextBox-31"
                  onChange={props.onChangeDate}
                  value={props.searchDrugOrder?.create_date || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-8"
              inline={true}
              width="3">
              <div
                id="CardAddNedDrugOrderItemUX-div-17"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardAddNedDrugOrderItemUX-label-27">
                  HN
                </label>
                <Input
                  id="CardAddNedDrugOrderItemUX-Input-32"
                  name="hn"
                  onChange={props.onChangeData}
                  value={props.searchDrugOrder?.hn || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-9"
              inline={true}
              width="3">
              <div
                id="CardAddNedDrugOrderItemUX-div-18"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardAddNedDrugOrderItemUX-label-28"
                  style={{minWidth: "max-content"}}>
                  Order Code
                </label>
                <Input
                  id="CardAddNedDrugOrderItemUX-Input-33"
                  name="order_code"
                  onChange={props.onChangeData}
                  value={props.searchDrugOrder?.order_code || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-10"
              inline={true}
              width="3">
              <div
                id="CardAddNedDrugOrderItemUX-div-19"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardAddNedDrugOrderItemUX-label-29">
                  Type
                </label>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardAddNedDrugOrderItemUX-Dropdown-34"
                  name="order_type"
                  onChange={props.onChangeData}
                  options={props.orderTypeOptions}
                  selection={true}
                  value={props.searchDrugOrder?.order_type || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-11"
              inline={true}
              width="3">
              <div
                id="CardAddNedDrugOrderItemUX-div-20"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardAddNedDrugOrderItemUX-label-30">
                  Drug
                </label>
                <Input
                  id="CardAddNedDrugOrderItemUX-Input-35"
                  name="drug_name"
                  onChange={props.onChangeData}
                  value={props.searchDrugOrder?.drug_name || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-12"
              inline={true}>
              <div
                id="CardAddNedDrugOrderItemUX-div-21"
                style={{ width: "100%", display: "flex" }}>

                <div
                  id="CardAddNedDrugOrderItemUX-div-22"
                  style={{ margin: "0px 20px" }}>

                  <div
                    id="CardAddNedDrugOrderItemUX-div-24">
                    {props.searchButton}
                  </div>
                </div>
                <div
                  id="CardAddNedDrugOrderItemUX-div-23">

                  <Button
                    color="orange"
                    id="CardAddNedDrugOrderItemUX-Button-25"
                    onClick={props.onClearFilter}>
                    Clear
                  </Button>
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardAddNedDrugOrderItemUX-div-2">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.drugOrderList}
            id="CardAddNedDrugOrderItemUX-Table-4"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardAddNedDrugOrderItemUX-div-3"
          style={{ marginTop: "20px" }}>

          <FormGroup
            id="CardAddNedDrugOrderItemUX-FormGroup-6"
            inline={true}
            style={{ justifyContent: "flex-end" }}>
            <FormField
              id="CardAddNedDrugOrderItemUX-FormField-13"
              inline={true}>
              <div
                id="CardAddNedDrugOrderItemUX-div-14"
                style={{ width: "100%" } }>

                <div
                  id="CardAddNedDrugOrderItemUX-div-15">
                  {props.saveButton}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardAddNedDrugOrderItemUX

export const screenPropsDefault = {}

/* Date Time : Mon Jul 14 2025 18:20:02 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"40px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.drugOrderList"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-Table-4"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ justifyContent: \"flex-end\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.saveButton"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Button",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-Button-25"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-label-26"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-label-27"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "Order Code"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "Type"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-label-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "Drug"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-label-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 31,
      "name": "DateTextBox",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-DateTextBox-31"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugOrder?.create_date || \"\""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Input",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-Input-32"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugOrder?.hn || \"\""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Input",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-Input-33"
        },
        "name": {
          "type": "value",
          "value": "order_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugOrder?.order_code || \"\""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 19,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-Dropdown-34"
        },
        "name": {
          "type": "value",
          "value": "order_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.orderTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugOrder?.order_type || \"\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Input",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddNedDrugOrderItemUX-Input-35"
        },
        "name": {
          "type": "value",
          "value": "drug_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugOrder?.drug_name || \"\""
        }
      },
      "seq": 35,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardAddNedDrugOrderItemUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
